/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Hubs_Signals_Faq_When_QInputs */

const en_directory_hubs_signals_faq_when_q = /** @type {(inputs: Directory_Hubs_Signals_Faq_When_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When do real audits replace preview scores?`)
};

const zh_directory_hubs_signals_faq_when_q = /** @type {(inputs: Directory_Hubs_Signals_Faq_When_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`真实审计什么时候替换预览分？`)
};

/**
* | output |
* | --- |
* | "When do real audits replace preview scores?" |
*
* @param {Directory_Hubs_Signals_Faq_When_QInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_hubs_signals_faq_when_q = /** @type {((inputs?: Directory_Hubs_Signals_Faq_When_QInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Hubs_Signals_Faq_When_QInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_hubs_signals_faq_when_q(inputs)
	return zh_directory_hubs_signals_faq_when_q(inputs)
});
export { directory_hubs_signals_faq_when_q as "directory.hubs.signals.faq.when_q" }